import styles from './dotseparator.module.scss';
import cn from 'classnames';

export function DotSeparator({ className }: { className?: string }): React.JSX.Element {
    const styling = cn(styles.dotSeparator, className);
    return <span className={styling}></span>;
}
